import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearAccessToken, isAccessTokenValid } from "./authToken";


const PrivateRoute = ({ children  }) => {
    const navigate = useNavigate();

  useEffect(() => {
    if (!isAccessTokenValid()) {
      clearAccessToken();
      navigate("/login");
    }
  }, [navigate]);
  
    return (
      <>
        {children}
      </>
    );
};
export default PrivateRoute;
